module.exports = __webpack_public_path__ + "static/media/uploadCloud.f34f419c.svg";